import {
	Pie,
	mixins
} from "vue-chartjs";
export default {
	extends: Pie,
	props: ["data", "options"],
	mounted() {
		this.renderChart(this.data, this.options);
	}
};


// WEBPACK FOOTER //
// ./src/views/components/dashboard/charts.js